import React from "react";
import RequesterContext from "./Context";

export default function withPairingRequester(Component) {
  return (props) => (
    <RequesterContext.Consumer>
      {(pairingRequester) => (
        <Component {...props} pairingRequester={pairingRequester} />
      )}
    </RequesterContext.Consumer>
  );
}
